import denzelPic from "@/public/images/artists/denzel.png";
import { Artist } from "@/types/types";

export const denzel = {
  id: "189",
  name: "Denzel",
  image: denzelPic,
  description: `Denzel's voice has a relaxed, confident vibe that's genuine and unforced. He shines in the deep lows and warm mids, making him a great fit for indie pop, R&B, and experimental electronica.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fdenzel-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Indie", "Soul", "Airy", "RnB"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 47,
        high: 72,
      },
      sweetSpot: 71,
    },
  },
} as const satisfies Artist;
